import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'worflowPipe'
})
export class WorflowPipePipe implements PipeTransform {

  transform(value: any, args?: any): any {
    return null;
  }

}
